import { Store } from 'redux';
import { Router } from '@remix-run/router/dist/router';

// Store
let _store: Store;

export const setStore = (store: Store) => {
    _store = store;
};

export const getStore = () => {
    if (!_store) {
        throw new Error('Redux store not initialized. Call setStore first.');
    }
    return _store;
};

// Router
let _router: Router;

export const setRouter = (router: Router) => {
    _router = router;
};

export const getRouter = () => {
    if (!_router) {
        throw new Error('Router not initialized. Call setRouter first.');
    }
    return _router;
};
